// api configuration
export const apiEndpoint: string = process.env.REACT_APP_API_URL || "";

export const apiKey: string = process.env.REACT_APP_API_KEY || "";
